<template>
  <div class="pie-chart-container">
    <canvas ref="canvas"></canvas>
  </div>
</template>

<script>
import { Pie } from 'vue-chartjs';

export default {
  extends: Pie,
  name: 'CallLogByDurationPieChart',
  props: {
    callLogs: {
      type: Array,
      required: true,
    },
  },
  methods: {
    updateChart() {
      if (this.callLogs.length === 0) return;

      const shortCount = this.callLogs.filter(call => call.duration_range === 'short').length;
      const mediumCount = this.callLogs.filter(call => call.duration_range === 'medium').length;
      const longCount = this.callLogs.filter(call => call.duration_range === 'long').length;

      this.renderChart(
        {
          labels: [
            this.$t('CALL_LOG_REPORT.DURATION.SHORT'),
            this.$t('CALL_LOG_REPORT.DURATION.MEDIUM'),
            this.$t('CALL_LOG_REPORT.DURATION.LONG'),
          ],
          datasets: [{
            data: [shortCount, mediumCount, longCount],
            backgroundColor: ['#3b82f6', '#f59e0b', '#ef4444'],
            borderWidth: 2,
            borderColor: '#fff',
          }],
        },
        {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              position: 'bottom',
            },
          },
        }
      );
    },
  },
  watch: {
    callLogs: {
      immediate: true,
      handler() {
        if (this.callLogs.length > 0) this.updateChart();
      },
    },
  },
  mounted() {
    this.updateChart();
  },
};
</script>

<style scoped>
.pie-chart-container {
  position: relative;
  height: 300px;
  width: 100%;
}
</style>